import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserContextService } from '../../service/context/user-context.service';

export const activeLocationInterceptor: HttpInterceptorFn = (req, next) => {
  const locationContext = inject(UserContextService);
  const activeLocationId = locationContext.location()?.id;
  if (!activeLocationId) {
    return next(req);
  }

  const clonedReq = req.clone({
    setHeaders: {
      'X-Active-Location-Id': activeLocationId
    }
  });

  return next(clonedReq);
};